module.exports = __webpack_public_path__ + "img/interpack-inactive.77b501f6.svg";